
// import { DatePicker } from 'antd';
import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import Axios from 'axios';
import { API_BASE_URL, GET_VSTORE_PROD, INSERT_PURCHASE_INVOICE } from '../../../Config';
import Swal from "sweetalert2";


const NewPOInvoice = () => {
    
    const [userDataSession, setUserDataSession] = useState([]);
    const [currentDate, setCurrentDate] = useState('');
    const [storesData, setStoresData] = useState([]);
    const [suppliersData, setSuppliersData] = useState([]);
    const [storeProducts, setStoreProducts] = useState([]);
    
    // const [editProducts, setEditProducts] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedStore, setSelectedStore] = useState(null);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    // const [inputValues, setInputValues] = useState([]);
    // const [amounts, setAmounts] = useState({});
    // const [paidAmount, setPaidAmount] = useState("");
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [paidAmount, setPaidAmount] = useState('');

    // #region Session userdetails
    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        const storesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Stores'));
        const supplierData = JSON.parse(sessionStorage.getItem('filteredDDLData_Supplier'));

        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
            setStoresData(storesData);
            setSuppliersData(supplierData);
            
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);
    
    const status = [
        { value: 'PENDING', label: 'PENDING' },
        { value: 'PAID', label: 'PAID' },
    ];

    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
    };

    const handleSupplierChange = (selectedOption) => {
        setSelectedSupplier(selectedOption);
    };

    const handleStoreChange = (selectedOption) => {
        setSelectedStore(selectedOption);
    };

    useEffect(() => {
        if(selectedStore) {
            const handleGetStoreProds = () => {        
                const requestPayload = {
                    OrgId: userDataSession.OrgId,
                    CategoryId: 0,
                    BarCode: "0",
                    ProductId: 0,
                    StoreId: selectedStore.value,
                    IsForSale: 1,
                    UserId: userDataSession.UserId,
                    Type: 1,
                };
    
                console.log(requestPayload, 'sending data to api');
            
                Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestPayload)
                .then(response => {
                    console.log(response.data, 'rrrrrrrr');
                    setStoreProducts(response.data.ResultData);
                    console.log(response.data.ResultData, 'store products...');
                })
                .catch(error => {
                    console.error("Error:", error);
                });
            };
            handleGetStoreProds();``
        }
    }, [selectedStore]);

    const handleProductSelectChange = (selectedOption) => {
        console.log(selectedProducts, 'sss sss sss ss')
        if (!selectedProducts.some(product => product.value === selectedOption.value)) {
            setSelectedProducts([...selectedProducts, selectedOption]);
        }
    };
    
    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setCurrentDate(formattedDate);
    }, []);

    const handleDeleteProduct = (index) => {
        const newSelectedProducts = [...selectedProducts];
        newSelectedProducts.splice(index, 1);
        setSelectedProducts(newSelectedProducts);
    };
    
   

    // const handleInputChange = (index, field, value) => {
    //     const updatedValues = {
    //         ...inputValues,
    //         [index]: {
    //             ...inputValues[index],
    //             [field]: value
    //         }
    //     };
    //     setInputValues(updatedValues);

    //     if (field === 'Quantity' || field === 'UnitPrice') {
    //         const updatedAmount = calculateAmount(updatedValues[index]?.Quantity, updatedValues[index]?.UnitPrice);
    //         setAmounts({
    //             ...amounts,
    //             [index]: updatedAmount
    //         });
    //     } else if (field === 'InvoicePrice') {
    //         setAmounts({
    //             ...amounts,
    //             [index]: value
    //         });
    //     }
    // };


    const [quantities, setQuantities] = useState({});
    const [invoices, setInvoices] = useState({});
    const [taxes, setTaxes] = useState({});
    const [discounts, setDiscounts] = useState({});
    const [rates, setRates] = useState({});
    const [cgsts, setCgsts] = useState({});
    const [sgsts, setSgsts] = useState({});
    const [igsts, setIgsts] = useState({});
    const [mrp, setMrp] = useState({});
    const [discountAmount, setDiscountAmount] = useState('');
    const [invoiceAmount, setInvoiceAmount] = useState('');

    const handleQuantityChange = (index, value) => {
        setQuantities({ ...quantities, [index]: value });
    };

    const handleInvoiceChange = (index, value) => {
        setInvoices({ ...invoices, [index]: value });
    };

    const handleTaxChange = (index, value) => {
        setTaxes({ ...taxes, [index]: value });
    };

    const handleDiscountChange = (index, value) => {
        setDiscounts({ ...discounts, [index]: value });
    };

    const handleMRPChange = (index, value) => {
        setMrp({ ...discounts, [index]: value });
    };

    const handleRateChange = (index, value) => {
        setRates({ ...rates, [index]: value });
    };

    const handleCgstChange = (index, value) => {
        setCgsts({ ...cgsts, [index]: value });
    };

    const handleSgstChange = (index, value) => {
        setSgsts({ ...sgsts, [index]: value });
    };

    const handleIgstChange = (index, value) => {
        setIgsts({ ...igsts, [index]: value });
    };



    // #region Handlesubmit
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);
    
        const requestPayload = {
            orgid: userDataSession.OrgId,
            userid: userDataSession.UserId,
            SupplierId: selectedSupplier.value,
            PurchaseInvoice: {
                Id: 0,
                StoreId: selectedStore.value,
                SupplierId: selectedSupplier.value,
                Status: selectedStatus.value,
                DiscountType: "0",
                DiscountAmount: parseFloat(discountAmount),
                InvoiceAmount: parseFloat(invoiceAmount),
                PaidAmount: parseFloat(paidAmount),
                InvoiceDate: currentDate,
                InvoiceStatus: 'PENDING',
                POStatus: 'INVOICE',
            },
            productdetails: selectedProducts?.map((prod, index) => ({
                detailid: 0,
                ProductId: prod.value,
                Quantity: quantities[index] || prod.Quantity,
                UOM: prod.UOM,
                UnitPrice: rates[index] || prod.UnitPrice,
                CGSTRate: cgsts[index] || prod.CGSTRate,
                SGSTRate: sgsts[index] || prod.SGSTRate,
                IGSTRate: igsts[index] || prod.IGSTRate,
                MRP: mrp[index] || prod.MRP,
                InvoicePrice: invoices[index] || prod.InvoicePrice,
            }))
        };

        console.log(requestPayload, 'sending data to api');
    
        Axios.post(`${API_BASE_URL}${INSERT_PURCHASE_INVOICE}`, requestPayload)
        .then(response => {
            console.log(response.data, 'rrrrrrrr');

            if (response.data[0].Success == 1) {
                setSubmitBtnLoading(false);

                // Show success message
                Swal.fire({
                    title: `Invoice Submitted Successfully.`,
                    icon: "success",
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        window.location.reload();
                    }
                });
            } else {
                setSubmitBtnLoading(false);

                Swal.fire({
                    title: "Error",
                    text: "Failed to Request Submit.",
                    icon: "error",
                });
            }
        })
            .catch(error => {
                console.error("Error:", error);
            });
    };

    const customStyles = {
        control: (provided) => ({
          ...provided,
          minHeight: "2rem",
          height: "2.4rem",
        }),
        valueContainer: (provided) => ({
          ...provided,
          height: "1rem",
          padding: "0 6px",
        }),
        input: (provided) => ({
          ...provided,
          margin: "0",
        }),
    };
    
     
    return (
        <div>
            {/* Add Purchase */}
            <div className="modal fade" id="new-purchase-invoice" >
                <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal" >
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title d-flex">
                                        <h4>New Invoice</h4>
                                        {/* <h4 className='ms-2'>({POObj && POObj.AutoGentransactionNo ? `PI-${POObj.AutoGentransactionNo}` : ''})</h4> */}
                                    </div>
                                    <button
                                        type="button"
                                        className="close d-flex ms-auto"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <label>Supplier Name</label>
                                                <Select
                                                    className="select"
                                                    value={selectedSupplier}
                                                    onChange={handleSupplierChange}
                                                    options={suppliersData?.map(supp => ({
                                                        value: supp.ItemId,
                                                        label: supp.ItemValue 
                                                    }))}
                                                    placeholder="Choose supplier"
                                                    styles={customStyles}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>Date</label>
                                                    <div className="input-groupicon calender-input">
                                                        <input
                                                            type='date'
                                                            className='form-control'
                                                            value={currentDate}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                                <label className="form-label">Status</label>
                                                <Select
                                                    options={status}
                                                    className="select"
                                                    placeholder="Choose"
                                                    onChange={handleStatusChange}
                                                    styles={customStyles}
                                                />
                                            </div>
                                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                                <label className="form-label">Store</label>
                                                <Select
                                                    className="select"
                                                    id="categorySelect"
                                                    value={selectedStore}
                                                    onChange={handleStoreChange}
                                                    options={storesData?.map(supp => ({
                                                        value: supp.ItemId,
                                                        label: supp.ItemValue 
                                                    }))}
                                                    placeholder="Choose store"
                                                    styles={customStyles}
                                                />
                                            </div>
                                            <div className='col-lg-3 col-md-4 col-sm-12'>
                                                <label className="form-label">Products</label>
                                                <Select
                                                    className="select"
                                                    placeholder="Choose store"
                                                    styles={customStyles}
                                                    options={storeProducts && storeProducts.map(supp => ({
                                                        value: supp.Id,
                                                        label: supp.ProductName 
                                                    }))}
                                                    onChange={handleProductSelectChange}
                                                />
                                            </div>
                                            <div className='col-lg-3 col-md-4 col-sm-12'>
                                                <div className="input-blocks me-3">
                                                    <label className="form-label">Discount</label>
                                                    <input
                                                        className='form-control'
                                                        placeholder='Enter discount amount'
                                                        value={discountAmount}
                                                        onChange={(e) => setDiscountAmount(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-lg-3 col-md-4 col-sm-12'>
                                                <div className="input-blocks me-3">
                                                    <label className="form-label">Invoice Amount</label>
                                                    <input
                                                        className='form-control'
                                                        placeholder='Enter invoice amount'
                                                        value={invoiceAmount}
                                                        onChange={(e) => setInvoiceAmount(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-2 mt-2">
                                            <div className="col-lg-12">
                                                <div className="modal-body-table">
                                                    <div className="table-responsive">
                                                        <table className="table datanew">
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Product</th>
                                                                    <th>Quantity</th>
                                                                    <th>Tax</th>
                                                                    <th>Discount</th>
                                                                    <th>MRP</th>
                                                                    <th>Rate</th>
                                                                    <th>CGST</th>
                                                                    <th>SGST</th>
                                                                    <th>IGST</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {selectedProducts?.map((product, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{product.label}</td>

                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                value={quantities[index] || ''}
                                                                                onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                value={mrp[index] || ''}
                                                                                onChange={(e) => handleMRPChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input 
                                                                                type="text" 
                                                                                className="form-control" 
                                                                                value={taxes[index] || product.Tax || ''}
                                                                                onChange={(e) => handleTaxChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                value={invoices[index] || ''}
                                                                                onChange={(e) => handleInvoiceChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input 
                                                                                type="text" 
                                                                                className="form-control" 
                                                                                value={discounts[index] || product.Discount || ''}
                                                                                onChange={(e) => handleDiscountChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input 
                                                                                type="text" 
                                                                                className="form-control" 
                                                                                value={rates[index] || product.Rate || ''}
                                                                                onChange={(e) => handleRateChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input 
                                                                                type="text" 
                                                                                className="form-control" 
                                                                                value={cgsts[index] || product.CGST || ''}
                                                                                onChange={(e) => handleCgstChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input 
                                                                                type="text" 
                                                                                className="form-control" 
                                                                                value={sgsts[index] || product.SGST || ''}
                                                                                onChange={(e) => handleSgstChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input 
                                                                                type="text" 
                                                                                className="form-control" 
                                                                                value={igsts[index] || product.IGST || ''}
                                                                                onChange={(e) => handleIgstChange(index, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <button onClick={() => handleDeleteProduct(index)} className="btn btn-danger"><i className='fa-regular fa-trash-can'></i></button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        <p>Total Discount:</p>
                                                        <p>Total Tax:</p>
                                                        <p>Total Amount:</p>
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-lg-4 col-md-4'>
                                                        <label className='form-label'>Paid Amount</label>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            placeholder='Enter paid amount'
                                                            value={paidAmount}
                                                            onChange={(e) => setPaidAmount(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-lg-4 col-md-4'>
                                                        <label className='form-label'>Payment Type</label>
                                                        <select className='form-select'>
                                                            <option>Choose payment mode</option>
                                                            <option value="UPI">UPI</option>
                                                            <option value="InternetBanking">Internet Banking</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-auto d-flex justify-content-end p-3">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                disabled={submitBtnLoading}
                                            >
                                                Cancel
                                            </button>
                                            <button className='btn btn-primary me-2' disabled={submitBtnLoading}>{submitBtnLoading ? 'Submitting...' : 'Submit'}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Purchase */}
        </div>
    )
}

export default NewPOInvoice
